exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n\tpadding: 1em;\n}\n\n.more-damage .button-area {\n  margin-bottom: 20px;\n}\n\n.more-damage .button-area a{\n  width: 230px;\n  text-align: center;\n}\n\n.more-damage .button-area .btn-warning {\n\tmargin-bottom: 1em;\n}\n\n.btn-warning \n{\n    background-color: #FFAE00 !important;\n}\n\n.damage-alert-modal .modal-body,\n.damage-alert-modal .modal-header {\n  padding: 20px 20px 0;\n}\n\n.modal-wrapper .modal-body {\n  font-size: 17px;\n}\n\n.modal-wrapper .modal-body .img-area .circle-img {\n  position: absolute;\n  width: 50px;\n  top: 0px;\n}\n\n.modal-wrapper .modal-body .img-area .hand-img {\n  position: absolute;\n  width: 50px;\n  top: 26px;\n}\n\n.modal-wrapper .modal-body .img-area {\n  margin: 20px 0;\n}\n\n.modal-wrapper .modal-action-area {\n  width: 100%;\n  border-top: 1px solid #ddd;\n  padding: 10px;\n  border-radius: 0;\n}\n\n.home-heading.modal-header {\n  border: 0;\n}\n\n.modal-action-area a {\n  font-size: 17px;\n}\n\n.damage-alert-modal .img-area .add-more-img {\n  margin: 50px 0;\n  width: 50px; \n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/alert-modal/alert-modal.component.css
// module id = ../../../../../src/app/modals/alert-modal/alert-modal.component.css
// module chunks = main